import BlankButton from "@pathwright/ui/src/components/button/BlankButton"
import ErrorBoundary from "@pathwright/ui/src/components/error/ErrorBoundary"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import View from "@pathwright/ui/src/components/ui/View"
import Footer from "global/footer/components/Footer"
import { Col } from "lib/core/components/grid"
import { ConnectStores } from "lib/core/store"
import * as urls from "lib/core/utils/urls"
import PropTypes from "prop-types"
import AboutAuthors from "./AboutAuthors"
import AboutDescription from "./AboutDescription"
import AboutSummary from "./AboutSummary"
import RelatedCourses from "./RelatedCourses"
import "./ResourceAbout.css"
import ResourceOfferings from "./offerings/ResourceOfferings"

const ResourceAbout = (
  { resource, offerings, authors, categories, prompt, offerings_loading },
  { permissions }
) => {
  return (
    <ErrorBoundary>
      <View.Primary className="ResourceAbout">
        <div className="ResourceAbout__wrapper">
          <Col sm={12} md={8}>
            <View paddingLeft paddingRight>
              {(resource != null ? resource.short_description : undefined) ? (
                <AboutSummary
                  {...Object.assign(
                    { canEdit: permissions.can_edit_resource },
                    resource
                  )}
                />
              ) : undefined}
              {(() => {
                if (resource != null ? resource.description : undefined) {
                  return (
                    <AboutDescription
                      {...Object.assign(
                        { canEdit: permissions.can_edit_resource },
                        resource
                      )}
                    />
                  )
                } else if (permissions.can_edit_resource) {
                  return (
                    <BlankButton
                      to={urls.modalRoute(
                        `/manage/resource/${resource.id}/details/`
                      )}
                      label={prompt}
                    />
                  )
                }
              })()}
              {(() => {
                if (authors != null ? authors.length : undefined) {
                  return (
                    <AboutAuthors
                      resource={resource}
                      authors={authors}
                      canEdit={permissions.can_edit_resource}
                    />
                  )
                } else if (
                  permissions.can_edit_resource &&
                  !resource.licensed_from_resource
                ) {
                  return (
                    <BlankButton
                      to={urls.modalRoute(
                        `/manage/resource/${resource.id}/details/`
                      )}
                      label="Add authors"
                    />
                  )
                }
              })()}
              {/* {categories?.length ? (
                <AboutCategories
                  resource={resource}
                  categories={categories}
                  canEdit={permissions.can_edit_resource}
                />
              ) : permissions.can_edit_resource &&
                !resource.licensed_from_resource ? (
                <BlankButton
                  to={urls.modalRoute(
                    `/manage/resource/${resource.id}/details/`
                  )}
                  label="Add categories"
                />
              ) : null} */}
            </View>
          </Col>
          <Col sm={12} md={4}>
            {(() => {
              if (
                (offerings != null ? offerings.length : undefined) ||
                __guard__(
                  resource != null ? resource.license_offerings : undefined,
                  (x) => x.length
                )
              ) {
                return <ResourceOfferings />
              } else if (offerings_loading) {
                return <LoadingCircle />
              }
            })()}
          </Col>
        </div>
        <RelatedCourses categories={categories} resource={resource} />
        <Footer location="About Page" />
      </View.Primary>
    </ErrorBoundary>
  )
}

ResourceAbout.displayName = "ResourceAbout"
ResourceAbout.contextTypes = { permissions: PropTypes.object }

const mapStateToProps = function (state, ownProps) {
  const { resource, offerings, offerings_loading } = state.resourceStore.state
  const { session } = state.authStore.state
  const { authors, categories } = resource
  let type = "course"
  if (resource && resource.resource_type === 30) type = "collection"
  if (resource && resource.resource_type === 20) type = "lesson"

  const prompt = `Add a ${type} description`

  return _.assign(
    {},
    {
      resource,
      offerings,
      authors,
      categories,
      prompt,
      offerings_loading
    },
    ownProps
  )
}

const stores = [
  { store: "school", watch: false },
  { store: "auth", watch: ["user"] },
  {
    store: "resource",
    watch: ["resource", "offering", "offerings", "offerings_loading"]
  }
]

export default ConnectStores(ResourceAbout, stores, {}, mapStateToProps)

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
